import React from 'react';

import { AppLogo } from '@atlaskit/navigation-system/top-nav-items';

import { useProductHomeDetails } from './use-product-home-details';

export function ProductHome(): React.JSX.Element {
	const { Icon, name, href, label, onClick } = useProductHomeDetails();

	return <AppLogo icon={Icon} name={name} href={href} onClick={onClick} label={label} />;
}
